<template>
  <a-drawer
    class="pwd__edit"
    :visible="visible"
    :width="650"
    title="修改密码"
    @ok="handleOk"
    @cancel="handleCancel"
    @close="handleCancel"
    :mask-closable="false"
    destroy-on-close
  >
    <a-form
      class="pwd__edit__form"
      :label-col="{ span: 6 }"
      :wrapper-col="{ span: 18 }"
      :form="form"
    >
      <a-form-item label="旧密码">
        <a-input
          v-decorator="['oldPass', {
            rules: [
              {
                required: true,
                message: '请输入密码',
              },
            ]
          }]"
          type="password"
          placeholder="旧密码"
          autocomplete="off"
        />
      </a-form-item>
      <a-form-item label="新密码">
        <a-input
          v-decorator="['newPass', {
            rules: [
              {
                required: true,
                message: '请输入密码',
                
              },
              {
                pattern: passwordExp,
                message: '密码需要大于9位，包含英文大小写、数字、特殊字符'
              }
            ]
          }]"
          type="password"
          placeholder="新密码"
          autocomplete="off"
        />
      </a-form-item>
      <a-form-item label="确认密码">
        <a-input
          v-decorator="['confirmPwd', {
            rules: [
              {
                validator: confirmPwdValidator,
              },
            ]
          }]"
          type="password"
          placeholder="请再次输入密码"
          autocomplete="off"
        />
      </a-form-item>
    </a-form>
    <div class="pwd__edit__action-list">
      <a-button
        @click="handleCancel"
        class="pwd__edit__action"
      >取消</a-button>
      <a-button
        type="primary"
        @click="handleOk"
        class="pwd__edit__action"
      >提交</a-button>
    </div>
  </a-drawer>
</template>

<script>
import { passwordExp } from '@/consts';

export default {
  props: {
    visible: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {
      passwordExp,
      form: this.$form.createForm(this, { name: 'pwd_edit' }),
    };
  },
  methods: {
    handleOk() {
      this.form.validateFields((err, values) => {
        if (!err) {
          const {
            confirmPwd,
            ...payload
          } = values;
          this.$emit('ok', payload);
        }
      });
    },
    handleCancel() {
      this.$emit('cancel');
    },
    confirmPwdValidator(_, value) {
      const { getFieldValue } = this.form;
      const password = getFieldValue('newPass');

      if (password && !value) {
        return new Error('请再次输入密码');
      }

      if (value !== password) {
        return new Error('两次输入的密码不一致');
      }

      return true;
    },
  },
};
</script>

<style lang="less" scoped>
.pwd__edit {
  &__form {
    padding-bottom: 80px;
  }
  
  &__action {
    &-list {
      position: absolute;
      z-index: 3;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      padding: 10px 16px;
      border-top: 1px solid var(--border-color-split);
      text-align: right;
      background-color: var(--main-bg);
    }
  }
}
</style>
